// extracted by mini-css-extract-plugin
module.exports = {"pager":"Pager_pager__SeOpf","item":"Pager_item__WLcoJ","link":"Pager_link__WdiOD","current":"Pager_current__eSOEF","next":"Pager_next__kcvPY","prev":"Pager_prev__FoRHQ"};